import React from 'react';

export default function Contact() {
  return (
    <section style={{ padding: '120px 64px', maxWidth: '1100px', margin: '0 auto' }}>
      <PageHeader title="Επικοινωνία" subtitle="Μιλήστε μας" />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'start' }}>
        {/* Left: text */}
        <div>
          <p style={{
            fontFamily: 'var(--font-display)',
            fontSize: '1.25rem',
            fontStyle: 'italic',
            fontWeight: 400,
            lineHeight: 1.5,
            color: 'var(--dark-gray)',
            marginBottom: '32px',
          }}>
            Θα χαρούμε να ακούσουμε από εσάς — για παραστάσεις, εργαστήρια, συνεργασίες.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {[
              { label: 'Instagram', value: '@blanda.gr' },
              { label: 'Facebook', value: 'blandaamke' },
              { label: 'Βάση', value: 'Αθήνα, Ελλάδα' },
            ].map(item => (
              <div key={item.label}>
                <p style={{
                  fontSize: '0.6rem',
                  letterSpacing: '0.16em',
                  textTransform: 'uppercase',
                  color: 'var(--accent)',
                  marginBottom: '6px',
                }}>{item.label}</p>
                <p style={{
                  fontSize: '1rem',
                  letterSpacing: '0.04em',
                  color: 'var(--black)',
                  fontFamily: 'var(--font-display)',
                  fontWeight: 400,
                }}>{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right: email CTA */}
        <div style={{
          background: 'var(--off-white)',
          padding: '56px 48px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
          <p style={{
            fontSize: '0.6rem',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: 'var(--accent)',
            marginBottom: '20px',
          }}>Email</p>

          <a
            href="mailto:info@blanda.gr"
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(1.4rem, 3vw, 2rem)',
              fontWeight: 300,
              letterSpacing: '0.04em',
              color: 'var(--black)',
              textDecoration: 'none',
              borderBottom: '1px solid var(--light-gray)',
              paddingBottom: '16px',
              marginBottom: '32px',
              display: 'block',
              transition: 'color 0.2s, border-color 0.2s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.color = 'var(--accent)';
              e.currentTarget.style.borderColor = 'var(--accent)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.color = 'var(--black)';
              e.currentTarget.style.borderColor = 'var(--light-gray)';
            }}
          >
            info@blanda.gr
          </a>

          <p style={{
            fontSize: '0.78rem',
            lineHeight: 1.9,
            color: 'var(--dark-gray)',
            fontWeight: 300,
            letterSpacing: '0.03em',
          }}>
            Στείλτε μας email για οποιαδήποτε πληροφορία.
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          section > div[style*="grid-template-columns"] {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
}

function PageHeader({ title, subtitle }) {
  return (
    <div style={{ marginBottom: '72px' }}>
      <p style={{
        fontSize: '0.62rem',
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        color: 'var(--accent)',
        marginBottom: '12px',
      }}>{subtitle}</p>
      <h1 style={{
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(2.5rem, 6vw, 5rem)',
        fontWeight: 300,
        letterSpacing: '0.04em',
        color: 'var(--black)',
        lineHeight: 1,
      }}>{title}</h1>
      <div style={{ width: '40px', height: '1px', background: 'var(--accent)', marginTop: '20px' }} />
    </div>
  );
}
